import { useEffect, useState } from 'react';
import { Tabs, TabsProps } from 'antd';
import DOMPurify from 'dompurify';

// services
import { isRTL } from 'core/services/language';

// models
import { Setting } from 'modules/settings/models/settings';

// styles
import styles from './style.module.scss';

// components
import CKEditorComponent from '../ckEditor/ckEditor';

interface InputProps {
	setting: Setting;
	languages: { code: string; name: string }[];
	edit: boolean;
	onChange: (value: string) => void;
}

function TextareaSettingsComponent({ setting, languages, edit, onChange }: InputProps) {
	const [tabItems, setTabItems] = useState<TabsProps['items']>([]);

	useEffect(() => {
		if (languages.length > 0) {
			const tempTabs: TabsProps['items'] = languages.map((el, i) => ({
				key: `${i}`,
				label: el.name,
				destroyInactiveTabPane: true,
				children: edit ? (
					<CKEditorComponent value={setting.value?.[el.code]} langCode={el.code} onChange={handleCkEditorChange} />
				) : (
					<div
						className={styles.viewDiv}
						dangerouslySetInnerHTML={{
							__html: DOMPurify.sanitize(setting.value?.[el.code] || ''),
						}}
					/>
				),
			}));

			setTabItems(tempTabs);
		}
	}, [languages, edit]);

	const handleCkEditorChange = (langCode: string, value: string) => {
		setting.value[langCode] = value;
		onChange(setting.value);
	};

	return (
		<Tabs
			tabPosition={isRTL() ? 'right' : 'left'}
			direction={isRTL() ? 'rtl' : 'ltr'}
			items={tabItems}
			className="textareaSettingTabs mt-4"
		/>
	);
}

export default TextareaSettingsComponent;
